import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'CONVERSATION_SETTINGS';

export const {
    action: fetch,
    success: fetchSuccess,
    failed: fetchFailed,
} = createAction(
    `${domain}/FETCH`,
    () => ({}),
    response => ({response}),
);

export const {
    action: update,
    success: updateSuccess,
    failed: updateFailed,
} = createAction(
    `${domain}/UPDATE`,
    hideAsParticipant => ({hideAsParticipant}),
    response => ({response}),
);
